import { render, staticRenderFns } from "./ItemSelectTriggerBehaviorEditorFromUserDefined.vue?vue&type=template&id=34981c86&scoped=true&"
import script from "./ItemSelectTriggerBehaviorEditorFromUserDefined.vue?vue&type=script&lang=ts&"
export * from "./ItemSelectTriggerBehaviorEditorFromUserDefined.vue?vue&type=script&lang=ts&"
import style0 from "./ItemSelectTriggerBehaviorEditorFromUserDefined.vue?vue&type=style&index=0&id=34981c86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34981c86",
  null
  
)

export default component.exports